export interface PostHeaderModel {
  id?: string;
  title?: string;
  yearRange?: string;
  startDate?: string;
  hideDate?: boolean;
}

export function postHeaderModelFactory(json?: any): PostHeaderModel {
  json = json || {};

  return {
    id: json["id"] || undefined as String,
    title: json["title"] || "",
    yearRange: json["yearRange"] || "",
    startDate: (json["startDate"] || "").split("T")[0],
    hideDate: !!json["hideDate"],
  } as PostHeaderModel;
}

export function postHeaderModelListFactory(json?: any): PostHeaderModel[] {
  json = Array.from(json || []);

  return json.map(item => postHeaderModelFactory(item)) as PostHeaderModel[];
}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/post-header.model.ts